var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-inline-inline-scroll"},[_c('div',{staticClass:"container-inline-inline-scroll__video-full",class:_vm.align},[_c('VideoMcpViewer',{staticClass:"container-video-multimedia",attrs:{"thumb":_vm.thumb,"regular-player":_vm.regular,"mcp-id":_vm.mcp,"video-uniq-id":_vm.videoUniq,"play-video":false,"bg-loop":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }